export default {
  mounted(el, binding) {
    const callback = binding.value

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          callback()
          observer.unobserve(el)
        }
      },
      { rootMargin: '200px' }
    )

    el.__vueIntersect__ = observer
    observer.observe(el)
  },

  unmounted(el) {
    el.__vueIntersect__?.disconnect()
    delete el.__vueIntersect__
  }
}